export const AddressProofEnum={
    DL:"DL",
    PASSPORT:"PASSPORT",
    VOTERID:"VOTERID",
    AADHAAR:"AADHAAR",
};
